import { useState } from 'react';

export const useValueChoice = () => {
  const [valueDrawerVisible, setValueDrawerVisible] = useState(false);
  // 为每个类别创建独立的选择状态
  const [selectedValues, setSelectedValues] = useState({
    '团队协作：': [],
    '诚信负责：': [],
    '客户满意：': [],
    '发现创新：': [],
    '系统思维：': []
  });

  const valueGroups = [
    {
      categoryName: "团队协作：",
      options: [
        { label: '心存谦卑，发现并欣赏他人的长处', value: '心存谦卑，发现并欣赏他人的长处' },
        { label: '人比事更重要，爱能包容一切过错', value: '人比事更重要，爱能包容一切过错' },
        { label: '相信一群平凡的人，能组成一个不平凡的团队', value: '相信一群平凡的人，能组成一个不平凡的团队' },
        { label: '人人平等，在爱里说诚实话', value: '人人平等，在爱里说诚实话' }
      ]
    },
    {
      categoryName: "诚信负责：",
      options: [
        { label: '行真善美，恨不义财', value: '行真善美，恨不义财' },
        { label: '诚实可信，说到做到，不隐藏真相', value: '诚实可信，说到做到，不隐藏真相' },
        { label: '做人一诺千金，做事全力以赴', value: '做人一诺千金，做事全力以赴' },
        { label: '勇于承担责任使你更优秀', value: '勇于承担责任使你更优秀' }
      ]
    },
    {
      categoryName: "客户满意：",
      options: [
        { label: '穿客户的鞋，客户是我们最好的老师', value: '穿客户的鞋，客户是我们最好的老师' },
        { label: '细节展现专业，多走一里路', value: '细节展现专业，多走一里路' },
        { label: '客户的独特性就是我们存在的理由', value: '客户的独特性就是我们存在的理由' },
        { label: '不让一点瑕疵破坏客人一生中唯一的旅程，一眚能掩大德', value: '不让一点瑕疵破坏客人一生中唯一的旅程，一眚能掩大德' }
      ]
    },
    {
      categoryName: "发现创新：",
      options: [
        { label: '好奇心，好头脑风暴', value: '好奇心，好头脑风暴' },
        { label: '第一个行动的，失败了也光荣；行动太迟，正确的决策也可能变成错误', value: '第一个行动的，失败了也光荣；行动太迟，正确的决策也可能变成错误' },
        { label: '以往的成功经验未必是今天问题的解决方案', value: '以往的成功经验未必是今天问题的解决方案' },
        { label: 'Do Without，自己创造条件达到目标', value: 'Do Without，自己创造条件达到目标' }
      ]
    },
    {
      categoryName: "系统思维：",
      options: [
        { label: 'Why goes before How, 先明确目的和意义，再决定步骤和方法', value: 'Why goes before How, 先明确目的和意义，再决定步骤和方法' },
        { label: '举一反三，不头痛医头、脚痛医脚，从根部解决问题', value: '举一反三，不头痛医头、脚痛医脚，从根部解决问题' },
        { label: '让我们走过的弯路，成为他人成功的捷径；让我们走过的捷径，成为后人永远的祝福', value: '让我们走过的弯路，成为他人成功的捷径；让我们走过的捷径，成为后人永远的祝福' },
        { label: '复杂的事情简单做，简单的事情认真重复做，重复的事情创造性地做，代码可以做的事情就不要人来做', value: '复杂的事情简单做，简单的事情认真重复做，重复的事情创造性地做，代码可以做的事情就不要人来做' }
      ]
    }
  ];

  const handleValueCheckboxChange = (categoryName, checkedValues) => {
    setSelectedValues(prev => ({
      ...prev,
      [categoryName]: checkedValues
    }));
  };

  // 获取所有选中的值（用于兼容现有代码）
  // const getAllSelectedValues = () => {
  //   console.log('所有选中的值:', Object.values(selectedValues).flat());
  //   return Object.values(selectedValues).flat();
  // };

  const handleValueDrawerClose = () => {
    setValueDrawerVisible(false);
  };

  const handleValueButtonClick = () => {
    setValueDrawerVisible(true);
  };

  return {
    valueDrawerVisible,
    selectedValues,
    valueGroups,
    handleValueCheckboxChange,
    handleValueDrawerClose,
    handleValueButtonClick,
    setValueDrawerVisible,
    setSelectedValues,
  };
};